module.exports = __webpack_public_path__ + "img/FF-Business-White.7cc6a374.png";